import { orchestrator } from 'satcheljs';
import {
    setHasScrolledInDetailsForm,
    resetRelatedContentViewState,
} from '../actions/publicActions';

export default orchestrator(resetRelatedContentViewState, () => {
    setHasScrolledInDetailsForm(false);
});
